<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">Stock</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">Stock</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="card card-success card-outline">
      <div class="card-body">
          <div class="row">
            <div class="col-sm-3">
                <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01">Por Categoria:</label>
                </div>
                <select class="custom-select" v-model="categoria" @change="listarStock(1,txtBuscar,ordenar,categoria, almacen)">
                    <option :value="0">=== Todos ===</option>
                    <option :value="cat.id" v-for="cat in arrayCategorias" :key="cat.id" v-text="cat.nombre"></option>
                </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01">Ordenar:</label>
                </div>
                <select class="custom-select" v-model="ordenar" @change="listarStock(1,txtBuscar,ordenar,categoria,almacen)">
                    <option value="Todos">=== Alfabético ===</option>
                    <option value="-cantidad">De Mayor a menor</option>
                    <option value="cantidad">De Menor a mayor</option>
                </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01">Almacen:</label>
                </div>
                <select class="custom-select" v-model="almacen" @change="listarStock(1,txtBuscar,ordenar,categoria,almacen)">
                    <option :value="0">=== Todos ===</option>
                    <option :value="al.id" v-for="al in arrayAlmacen" :key="al.id" v-text="al.nombre"></option>
                </select>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="input-group">
                    <input type="search" v-model="txtBuscar" @keyup="listarStock(1,txtBuscar,ordenar,categoria,almacen)" class="form-control form-control-md" placeholder="Buscar producto">
                    <div class="input-group-append">
                        <button type="submit" class="btn btn-md btn-default">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
              <div class="col-sm-1 text-right">
                <button class="btn btn-success btn-flat btn-sm" @click="exportarExcel()"><i class="far fa-file-excel"></i> Excel</button>
              </div>
          </div>
          
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-success">
                      <tr>
                          <th>Producto</th>
                          <th>Marca</th>
                          
                          <th>Modelo</th>
                          <th>Serie</th>
                          <th>Cod. SKU</th>
                          <th>Fecha Vencim.</th>
                          <th>Categoria</th>
                          <th>Stock</th>
                          <th>Almacen</th>
                          <th>Opciones</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="a in arrayStock" :key="a.id">
                          <td v-text="a.producto"></td>
                          <td v-text="a.marca"></td>
                          <td v-text="a.modelo"></td>
                          <td v-text="a.serie"></td>
                          <td v-text="a.codigoSku"></td>
                          <td>{{fechaFormateada(a.fvencimiento)}}</td>
                          <td v-text="a.categoria"></td>
                          <td><strong :style="{ color: a.cantidad == 0 ? 'red' : 'black' }">{{a.cantidad}}</strong></td>
                          <td>{{ a.almacen }}</td>
                          <td>
                            <button class="btn btn-sm btn-warning tooltip-btn" data-tooltip="Editar Stock" @click="abrirModal(a)"><i class="fas fa-edit"></i></button>&nbsp;
                              <button class="btn btn-sm tooltip-btn" :data-tooltip="a.activo?'Anular':'Restaurar'"  :class="a.activo?'btn-danger':'btn-success'" @click="eliminarStock(a.id,a.producto,a.activo)">
                                <i class="fas" :class="a.activo?'fa-trash-alt':'fa-trash-restore-alt'"></i>
                              </button>
                              &nbsp;
                              <span v-if="a.activo" class="badge badge-success">Habilitad</span>
                              <span v-else class="badge badge-danger">Anulado</span>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <!-- Agrega el paginador aquí -->
          <div class="row">
              <div class="col-sm-6">
                  <span>Registros: {{ totalRegistros }}</span>
              </div>
              <div class="col-sm-6">
                  <ul class="pagination pagination-sm justify-content-end">
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToFirstPage" :disabled="isOnFirstPage">Primero</a>
                      </li>
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToPreviousPage" >Anterior</a>
                      </li>
                      <li class="page-item" :class="{ active: currentPage === page }" v-for="page in visiblePages" :key="page">
                          <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToNextPage" >Siguiente</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToLastPage" :disabled="isOnLastPage">Último</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      

  </div><!-- /.card -->

  <!--- MODAL ALMACEN --->
     <div v-if="showModal">
      <div class="modal">
          <div class="modal-overlay"></div>
              <div class="modal-content" v-on:keyup.enter = "actualizarStock()">
                  <div class="modal-header bg-primary text-white">
                      <h4>Editar Stock</h4>
                      <button type="button" class="close" @click="cerrarModal()">&times;</button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Producto:</label>
                          <div class="col-sm-8">
                            <label class="col-form-label">{{ tituloModal }}</label>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Modelo-Serie-F.Ven:</label>
                          <div class="col-sm-8">
                              <label class="col-form-label">{{modeloseriefven}}</label>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Cantidad:</label>
                          <div class="col-sm-8">
                              <input type="number" class="form-control" v-model="cantidad" placeholder="0">
                          </div>
                      </div>                
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                      <button type="button" class="btn btn-primary" @click="actualizarStock()">ACTUALIZAR</button>
                  </div>
              </div>
          </div>
          
      </div>
  <!--- FIN MODAL ALMACEN --->

    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Grabando...</span>
        </div>
        <p class="text-light mt-3">Procesando, espere...</p>
    </div>
</template>

<script>
    export default{
      data(){
          return{
            idStock:'',
            cantidad:0,
            total:0,
            precioCompra:'',
            arrayAlmacen:[],
            arrayStock:[],
            proporcion_um:'',
            uniMedidaTxt:'',
            categoria:0,
            almacen:0,
            errorStock:0,
            
            showModal: false,
            tituloModal:'',

            showModalPrecio:false,
            tituloModalPrecio:'',
            producto:'',
            unidadMedidas:[],
            errorPrecio:0,
            accion:'',
                        
            arrayMostMsj:[],
            idEmpresa:'',
            
            txtBuscar:'',
            ordenar:'Todos',

            currentPage: 1,
            totalPages: 0,
            listporPage: 15, // paginador coincide con DRF
            visiblePages: [], // Páginas visibles en el paginado
            totalPagesToShow: 5, // Cantidad de páginas visibles en el paginado
            totalRegistros:0,

            showTooltip: false,
            localSocket:null,
            loading:false,
          }
      },
      computed: {
          isOnFirstPage() {
          return this.currentPage === 1;
          },
          isOnLastPage() {
          return this.currentPage === this.totalPages;
          },
      },
      methods:{
          updateVisiblePages() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShow / 2);

              let startPage = Math.max(this.currentPage - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPage + halfTotalPagesToShow, this.totalPages);

              if (this.totalPages > this.totalPagesToShow) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPages) {
                  startPage = Math.max(endPage - this.totalPagesToShow + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShow - 1, this.totalPages);
                  }
              }

              this.visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPage(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPage = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarStock(pageNumber,'',this.ordenar,'','');
          },
          goToPreviousPage() {
              if (this.currentPage > 1) {
                  this.currentPage -= 1;
                  this.listarStock(this.currentPage,'',this.ordenar,'','');
              }
          },
          goToNextPage() {
              if (this.currentPage < this.totalPages) {
                  this.currentPage += 1;
                  this.listarStock(this.currentPage,'',this.ordenar,'','');
              }
          },
          goToFirstPage() {
              if (this.currentPage !== 1) {
                  this.currentPage = 1;
                  this.listarStock(this.currentPage,'',this.ordenar,'','');
              }
          },
          goToLastPage() {
              if (this.currentPage !== this.totalPages) {
                  this.currentPage = this.totalPages;
                  this.listarStock(this.currentPage,'',this.ordenar,'','');
              }
          },
          listarStock(pageNumber = 1,txtBuscar,ordenar,categoria, almacen){ console.log(categoria)
              let me = this
              this.$axios.get(`apinventario/stock/?page=${pageNumber}&search=${txtBuscar}&ordenar=${ordenar}&categoria=${categoria}&almacen=${almacen}`)
              .then(function(response){
                  me.arrayStock = response.data.results
                  me.currentPage = pageNumber
                  me.totalPages = Math.ceil(response.data.count / me.listporPage)
                  me.totalRegistros = response.data.count
                  me.updateVisiblePages()
              })
          },
          listarCategorias(){
            let me = this
              this.$axios.get(`apinventario/categoriastrue/?idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.arrayCategorias = response.data
              })
              console.log(this.arrayCategorias)
          },
          abrirModal(data=[]){
                this.showModal = true
                this.tituloModal = data.producto
                this.idStock = data.id
                this.cantidad = data.cantidad
                this.modeloseriefven = 'Modelo: '+data.modelo+'. Serie: '+data.serie+'. F.Venci. '+this.fechaFormateada(data.fechaVencimiento)
          },
          cerrarModal(){
                this.showModal = false;
                this.idStock = ''
                this.cantidad = ''
          },
          validarStock(){
            const numerosExp = /^\d*\.?\d*$/;
            this.errorStock = 0
            this.arrayMostMsj = []
              
            if(!numerosExp.test(this.cantidad) || this.cantidad === '') this.arrayMostMsj.push("Cantidad no debe estar vacio")
            
            if(this.arrayMostMsj.length) this.errorStock = 1
            return this.errorStock
          },
          actualizarStock(){
            if(this.validarStock()){
                this.arrayMostMsj.forEach(element => {
                    this.$toastr.error(element,'Atencion!')
                });
                return
            }
            
            let me = this
            me.loading=true
            this.$axios.patch(`apinventario/stock/`+me.idStock+`/`,{
                cantidad: me.cantidad,
            })
            .then(function(response){
                console.log(response)
                me.listarStock(me.currentPage,me.txtBuscar,me.ordenar,me.categoria,me.almacen)
                me.cerrarModal()
                me.$toastr.success('Stock actualizado', 'Actualizado');
            })
            .catch(function (error) {
            console.log(error)
            })
            .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
            
          },
          eliminarStock(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text: activo ? 'Presione si para anular' : 'Presione si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo ? 'Anular' : 'Restaurar',
              }).then((result) => {
                me.loading=true
              if (result.isConfirmed) {
                  this.$axios.patch(`apinventario/stock/`+id+`/`,{
                    activo : activo ?  0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarStock(me.currentPage,me.txtBuscar,me.ordenar,me.categoria,me.almacen)
                      me.cerrarModal()
                      if(activo) me.$toastr.success('Producto anulado', 'Anulado')
                      else me.$toastr.success('Producto restaurado', 'Restaurado')
                      
                  })
                  .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
              }else{me.loading=false}
              })
          },
        exportarExcel(){
            window.open(`impresiones/almacenexcel/${this.categoria}/${this.idEmpresa}/`, '_blank')
        },
        fechaFormateada(fecha) {
            if(fecha == null){
                return ''
            }else{
                const partes = fecha.split('-')
                return `${partes[2]}/${partes[1]}/${partes[0]}`
            }
        },
        listarAlmacen(){
              let me = this
              this.$axios.get(`apiempresa/almacen/`)
              .then(function(response){
                if(response.data.length){
                    me.arrayAlmacen = response.data
                }
              })
              console.log(this.arrayAlmacen)
          },
      },
          
      watch: {
          currentPage() {
          // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePages();
          },
          totalPages() {
          // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePages();
          },
      },
      created(){
        
      },
      mounted(){
        this.idEmpresa = localStorage.getItem('idEmpresa')
        this.$socket.onopen = () => {
            console.log('Conexión WebSocket establecida en Almacen');
            // Puedes enviar el mensaje después de que la conexión se haya establecido
            //this.enviarMensaje();
        }
        this.$socket.onmessage = (event) => {
            const data = JSON.parse(event.data)
            console.log('mensaje onmessage de almacen')
            console.log(data.message)
            if(data.message === 'nuevo producto'){this.$toastr.success('Nuevo producto agregado', 'Producto agregado');}
            if(data.message === 'nueva compra'){this.$toastr.success('Stock actualizado', 'Actualizacion Stock');}
            this.listarStock(1,this.txtBuscar,this.ordenar,this.categoria,this.almacen)
        }
        
        this.listarCategorias()
        this.listarStock(1,this.txtBuscar,this.ordenar,this.categoria,this.almacen)
        this.updateVisiblePages()
        this.listarAlmacen()
        
      },
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
/* Estilo base del botón */
.tooltip-btn {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* Estilo del tooltip */
.tooltip-btn::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px 10px;
  
  white-space: nowrap;
  border-radius: 4px;
  top: -30px; /* Ajusta la posición vertical según tus necesidades */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}
/* Mostrar el tooltip al hacer hover */
.tooltip-btn:hover::before {
  opacity: 1;
  visibility: visible;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>